import type react from 'react'
import { useEffect, useState } from 'react'

import { SaleChannel } from '@/constants'
import type { Property, PropertyValue } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'

import DrawBottom from '../DrawBottom'

interface SpecificationsType {
  specifications: Property[]
  openSpecModal: boolean
  productName?: string
  setOpenSpecModal: react.Dispatch<react.SetStateAction<boolean>>
}

export const Specifications = ({
  specifications,
  openSpecModal = false,
  setOpenSpecModal,
  productName,
}: SpecificationsType) => {
  const [isOpenDraw, setIsOpenDraw] = useState(openSpecModal)

  const specificationsData = specifications?.filter(
    item => !item?.policy && item?.channels?.includes(SaleChannel.B2C)
  )

  useEffect(() => setIsOpenDraw(openSpecModal), [openSpecModal])

  const renderSpecificationsHighlight = (item: Property): react.ReactNode => {
    switch (item.type as string) {
      case 'multipleSelect':
        return item.values.map((e: PropertyValue, i: number) => {
          return (
            <span
              key={i}
              className="mr-1 inline-block after:content-[','] last:mr-0 last:after:content-[unset]"
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'singleSelect':
        return item.values.map((e: PropertyValue, i: number) => {
          return e.link ? (
            <span
              className="mr-1 inline-block cursor-pointer  after:content-[','] last:mr-0 last:after:content-[unset]"
              key={i}
            >
              {getTranslate(e.value)}
            </span>
          ) : (
            <span
              className="mr-1 inline-block after:content-[','] last:mr-0 last:after:content-[unset]"
              key={i}
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'input':
        return <span>{getTranslate(item.value)}</span>
      default:
        break
    }
  }

  const renderSpecificationsItem = (item: Property): react.ReactNode => {
    switch (item.type as string) {
      case 'multipleSelect':
        return item.values.map((e: PropertyValue, i: number) => {
          return (
            <span
              key={i}
              className="mr-1 block after:content-[','] last:mr-0 last:after:content-[unset]"
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'singleSelect':
        return item.values.map((e: PropertyValue, i: number) => {
          return (
            <span
              className="mr-1 inline-block after:content-[','] last:mr-0 last:after:content-[unset]"
              key={i}
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'input':
        return <span>{getTranslate(item.value)}</span>
      default:
        break
    }
  }

  return (
    <section className='information mb-2 overflow-hidden rounded-xl bg-white px-2 py-4'>
      <div className='mb-3 flex w-full items-center justify-between'>
        <h6 className='text-sm font-semibold text-dark-900'>
          Thông số kỹ thuật
        </h6>
        <button
          className='viewMore text-sm text-primary-base'
          onClick={() => setIsOpenDraw(true)}
        >
          Xem tất cả
        </button>
      </div>

      <div className='highLightSpec grid h-full w-full grid-cols-2 gap-2'>
        {specificationsData &&
          specificationsData.slice(0, 4).map((item, index) => {
            return (
              <div
                key={index}
                className={`relative flex h-full w-full flex-wrap rounded-lg bg-gray-50 p-2 leading-none`}
              >
                <div className='label line-clamp-1 w-full overflow-hidden text-ellipsis text-xs font-semibold leading-normal text-dark-900'>
                  {getTranslate(item.name)}
                </div>

                <div className='value line-clamp-2 w-full overflow-hidden text-ellipsis text-xs leading-snug text-dark-500'>
                  {renderSpecificationsHighlight(item)}
                </div>
              </div>
            )
          })}
      </div>

      <DrawBottom
        open={isOpenDraw}
        onClose={() => {
          setIsOpenDraw(false)
          setOpenSpecModal(false)
        }}
        title={'Thông số kỹ thuật'}
      >
        <>
          <h6 className='mb-3 text-sm font-semibold text-dark-900'>
            {productName}
          </h6>
          {specificationsData &&
            specificationsData
              .filter(item => !item.policy)
              .map((item, index) => {
                if (getTranslate(item.value) != '' || item.values.length > 0) {
                  return (
                    <div
                      key={index}
                      className='flex w-full flex-wrap justify-center border-b border-white-500 py-2'
                    >
                      <span className='label line-clamp-1 block max-w-[40%] flex-40 overflow-hidden text-ellipsis text-sm font-semibold leading-[20px] text-dark-800'>
                        {getTranslate(item.name)}
                      </span>
                      <span
                        className={`${
                          item.type === 'multipleSelect'
                            ? 'inline-grid'
                            : 'flex'
                        } value w-full max-w-[60%] flex-60 pl-2 text-sm leading-[20px] text-dark-800`}
                      >
                        {renderSpecificationsItem(item)}
                      </span>
                    </div>
                  )
                }
              })}
        </>
      </DrawBottom>
    </section>
  )
}

export default Specifications
